"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIT_SESSIONSIG_AUTHORIZATION_SCHEMA_PREFIX = exports.SERVICE_URL_BY_LIT_NETWORK = void 0;
const constants_1 = require("@lit-protocol/constants");
const SERVICE_URL_BY_NETWORKTYPE = {
    TestNetworks: 'https://test.wrapped.litprotocol.com/encrypted',
    Production: 'https://wrapped.litprotocol.com/encrypted',
};
exports.SERVICE_URL_BY_LIT_NETWORK = {
    [constants_1.LitNetwork.DatilDev]: SERVICE_URL_BY_NETWORKTYPE.TestNetworks,
    [constants_1.LitNetwork.DatilTest]: SERVICE_URL_BY_NETWORKTYPE.TestNetworks,
    [constants_1.LitNetwork.Datil]: SERVICE_URL_BY_NETWORKTYPE.Production,
    [constants_1.LitNetwork.Cayenne]: SERVICE_URL_BY_NETWORKTYPE.TestNetworks,
    [constants_1.LitNetwork.Manzano]: SERVICE_URL_BY_NETWORKTYPE.TestNetworks,
    [constants_1.LitNetwork.Habanero]: SERVICE_URL_BY_NETWORKTYPE.Production,
};
exports.LIT_SESSIONSIG_AUTHORIZATION_SCHEMA_PREFIX = 'LitSessionSig:';
//# sourceMappingURL=constants.js.map